export const ADDED_ACTION = 'ADDED_ACTION';
export const EDITED_ACTION = 'EDITED_ACTION';
export const DELETED_ACTION = 'DELETED_ACTION';